import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { ProfileServiceConfigurationService } from './profile-service-configuration.service';
import { UserwayFeature } from './userway-feature';

// Features applied via CSS filter on the host's <html>. These propagate to iframe
// pixels through rasterization, so re-applying them inside the iframe causes a
// double effect (e.g. invert ∘ invert = identity). Force them off when forwarding.
const HOST_ONLY_FEATURES: UserwayFeature[] = [
  UserwayFeature.Contrast,
  UserwayFeature.Saturation,
];

@Injectable()
export class UserwayService {
  private _settings$ = new Subject<any>();
  public settings$ = this._settings$.asObservable();

  constructor(private profileServiceConfigurationService: ProfileServiceConfigurationService) {}

  init(): void {
    this.profileServiceConfigurationService.state$
      .pipe(
        filter((c) => !!c && !!c.userWayAccessibilityId),
        take(1)
      )
      .subscribe((config) => {
        this.loadWidget(config.userWayAccessibilityId);
        this.listenForSettingsChanges();
      });
  }

  private loadWidget(accountId: string) {
    const s = document.createElement('script');
    s.setAttribute('data-account', accountId);
    s.setAttribute('src', 'https://cdn.userway.org/widget.js');
    (document.body || document.head).appendChild(s);
  }

  private listenForSettingsChanges() {
    window.addEventListener('message', (event) => {
      if (
        event.data &&
        event.data.isUserWay &&
        event.data.action === 'setProperties'
      ) {
        this._settings$.next(this.stripHostOnlyFeatures(event.data));
      }
    });
  }

  private stripHostOnlyFeatures(data: any): any {
    if (!data || !data.settings) {
      return data;
    }
    const settings = { ...data.settings };
    for (const key of HOST_ONLY_FEATURES) {
      if (settings[key]) {
        settings[key] = { ...settings[key], value: 0 };
      }
    }
    return { ...data, settings };
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/userway.service.ts